import { useGameStore } from '../GameStoreContext.ts';
export const useMyPerspectiveColor = ()=>{
    const myColor = useGameStore((state)=>state.myColor);
    const firstPlayerColor = useGameStore((state)=>state.gameDetails.playOrder[0]);
    const isMyColorSpectator = useGameStore((state)=>state.isMyColorSpectator);
    if (isMyColorSpectator) return firstPlayerColor;
    return myColor;
};
